import { healthCheck } from '@reader-tracker/shared/lib/supabase'
import { useAuthStore } from '@reader-tracker/shared/stores/authStore'
import { useEffect, useState } from 'react'
import { version } from '../../../package.json'

export default function AboutPage() {
  const [isHealthy, setIsHealthy] = useState<boolean | null>(null)
  const profile = useAuthStore((s) => s.profile)

  useEffect(() => {
    const check = async (): Promise<void> => {
      const isHealthy = await healthCheck()
      setIsHealthy(isHealthy)
    }
    check()
  }, [])

  return (
    <div className="mx-auto max-w-2xl px-4 py-12">
      <h1 className="mb-6 font-bold text-3xl">About</h1>
      <div className="rounded-lg border border-gray-200 bg-white p-6 shadow-sm">
        <dl className="space-y-4">
          <div className="flex items-center justify-between">
            <dt className="font-medium text-gray-500 text-sm">Version</dt>
            <dd className="font-mono text-gray-900 text-sm">{version}</dd>
          </div>
          <div className="flex items-center justify-between">
            <dt className="font-medium text-gray-500 text-sm">DB Health</dt>
            <dd className="font-mono text-gray-900 text-sm">
              {isHealthy === null ? 'checking…' : isHealthy ? 'ok' : 'error'}
            </dd>
          </div>
          {profile && (
            <>
              <div className="flex items-center justify-between">
                <dt className="font-medium text-gray-500 text-sm">Name</dt>
                <dd className="font-mono text-gray-900 text-sm">
                  {[profile.first_name, profile.last_name]
                    .filter(Boolean)
                    .join(' ') || '—'}
                </dd>
              </div>
              <div className="flex items-center justify-between">
                <dt className="font-medium text-gray-500 text-sm">Role</dt>
                <dd className="font-mono text-gray-900 text-sm">
                  {profile.role}
                </dd>
              </div>
              <div className="flex items-center justify-between">
                <dt className="font-medium text-gray-500 text-sm">Phone</dt>
                <dd className="font-mono text-gray-900 text-sm">
                  {profile.phone ?? '—'}
                </dd>
              </div>
            </>
          )}
        </dl>
      </div>
    </div>
  )
}
